type Props = {
  title: string;
  description: string;
};

export const Notification = ({ title, description }: Props) => (
  <div>
    <div className="text-red-500 font-bold">{title}</div>
    <div>{description}</div>
  </div>
);
